<template>
  <div class="track columns is-vcentered is-mobile">
    <div
      class="column cover is-narrow"
    >
      <div
        class="play"
        @click="playSfx"
      />
      <img :src="sfx.artworkUrl">
    </div>

    <div class="column">
      <p class="text label-medium sfx-title is-hidden-mobile">
        {{ sfx.description }}
      </p>
      <p class="text label-medium sfx-title is-hidden-tablet is-hidden-desktop">
        {{ sfx.shortDescription }}
      </p>
      <p class="text small sfx-subtitle">
        {{ sfx.category }} | {{ sfx.subCategory }}
      </p>
    </div>

    <div
      class="column is-narrow"
      style="width: 50px;"
    >
      <span class="text tiny color-bluegrey3">{{ sfx.duration|formattedDuration }}</span>
    </div>
    <div class="column is-narrow">
      <div class="buttons are-small">
        <b-tooltip
          :label="downloadButtonText"
          type="is-dark"
          position="is-left"
        >
          <a
            class="icon-button"
            :class="{
              'download': !disableDownload,
              'download-muted': disableDownload
            }"
            @click="handleSfxDownload"
          />
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import sfxClient from '@/api/sfx.js'

export default {
  name: 'SfxListItem',

  props: {
    sfx: {
      type: Object,
      required: true
    }
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters['auth/isLoggedIn']
    },

    currentSubscription: function () {
      return this.$store.getters['subscriptions/currentSubscription']
    },

    disableDownload: function () {
      return this.isLoggedIn && this.currentSubscription && !this.currentSubscription.includes_sfx
    },

    downloadButtonText: function () {
      if (this.disableDownload) {
        return 'Contact support to upgrade and get SFX'
      }
      return 'Download'
    }
  },

  methods: {
    playSfx () {
      if (this.$store.getters['player/isPlaybackBlocked']) {
        this.$store.dispatch('common/startSignupWorkflow')
        return
      }
      if (this.$store.getters['player/isPlaybackSoftBlocked']) {
        this.$store.dispatch('common/startSignupWorkflow')
      }
      this.$store.dispatch('player/playTrack', this.sfx.pk)
    },

    handleSfxDownload () {
      if (this.disableDownload) {
        return
      }
      if (this.isLoggedIn) {
        if (this.currentSubscription && this.currentSubscription.includes_sfx) {
          sfxClient.downloadPseSfx(this.sfx.pk)
            .then((response) => {
              window.location = response.data.downloadUrl
            })
            .catch((error) => console.log(error))
        } else {
          this.$store.dispatch('subscriptions/showPlanSelectionModal')
        }
      } else {
        this.$store.dispatch('user/showSignupModal')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/_variables.scss";
.sfx-title {
  color: $bluegrey2;
}
</style>
